// List filters are plain objects keyed by the API parameter they are sent as,
// where 'all' or '' means "not filtered".

const isUnfiltered = (value) => value === 'all' || value === '';

export const countActiveFilters = (filters) =>
  Object.values(filters).filter((value) => !isUnfiltered(value)).length;

/** The filters as list API parameters, leaving out the unfiltered ones. */
export const filterParams = (filters) =>
  Object.fromEntries(
    Object.entries(filters).map(([name, value]) => [name, isUnfiltered(value) ? undefined : value])
  );
